import { ruleGroupsSchema } from "@/components/apply-to/rule-groups.schema.ts";
import i18n from "i18next";
import { z } from "zod";

export const buildFolderSchema = () => {
  const required = i18n.t("errors:field_required");

  return z.object({
    title: z.string({ error: required }).min(1, required),
    view_documents_rule_groups: ruleGroupsSchema(),
    edit_documents_rule_groups: ruleGroupsSchema(),
  });
};

export type FolderSchema = z.infer<ReturnType<typeof buildFolderSchema>>;
